import { LoadingResponse } from "src/app/common/interfaces/loading-response";

export const createLoadingResponse = <T = any>(
  result: T | null = null,
  loading: boolean = false,
  loaded: boolean = false
): LoadingResponse<T> => ({
  result,
  loading,
  loaded
});

export const createPendingResponse = () => createLoadingResponse(null, true, false);
export const createFulfilledResponse = <T = any>(result: T) => createLoadingResponse<T>(result, false, true);
export const createRejectedResponse = <T = any>(result?: T) => createLoadingResponse<T>(result, false, false);
